import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Footer from '../Footer/Footer';
import EnrollmentHeader from './EnrollmentHeader/EnrollmentHeader';

export default function EnrollmentLayoutFP() {
	return (
		<Box
			sx={{
				backgroundColor: 'background.paper',
				display: 'flex',
				flexDirection: 'column',
				minHeight: '100vh',
				width: '100vw',
				pt: 0,
				mt: 0,
			}}
		>
			<EnrollmentHeader />
			<Box
				component="main"
				sx={{
					flexGrow: 1,
					height: '100%',
					position: 'relative',
				}}
			>
				<Box
					sx={{
						backgroundColor: 'surface.tertiary',
						position: 'absolute',
						width: '100%',
						height: { xs: '2rem', md: '22.25rem' },
					}}
				/>
				<Box
					sx={{
						backgroundColor: 'background.paper',
						margin: {
							xs: '2rem auto 0',
							md: '2.5rem auto 0',
						},
						maxWidth: '35.75rem',
						padding: '2.5rem 2.5rem 5rem',
						position: 'relative',
					}}
				>
					<Outlet />
				</Box>
			</Box>
			<Footer />
		</Box>
	);
}
